import { render, staticRenderFns } from "./ProductsView.vue?vue&type=template&id=0a3ee0ec"
import script from "./ProductsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProductsView.vue?vue&type=style&index=0&id=0a3ee0ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports